import React, { useEffect, useMemo, useState } from "react";
import Header from "../../layouts/Header";
import Footer from "../../layouts/Footer";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";

import {
  Card,
  Row,
  Col,
  Form,
  Button,
  Spinner,
  Alert,
  InputGroup,
  Badge,
  Table,
  Modal,
  Toast,
  ToastContainer,
  Tabs,
  Tab,
  Pagination,
} from "react-bootstrap";

import axios from "axios";

import {
  ArrowLeft,
  Briefcase,
  Folder,
  Calendar,
  Trash,
  Receipt,
  Tag,
  ClockHistory,
  Eye,
  Search,
  PlusCircle,
  Wallet,
  ExclamationTriangle,
  PersonPlus,
  People,
  Envelope,
  Phone,
  Person,
  CheckCircle,
  XCircle,
  InfoCircle,
} from "react-bootstrap-icons";
import { API_BASE_URL } from "../../constants/api_constants";


const CATEGORIES_ENDPOINT = `${API_BASE_URL}/taxes-categories`;
const TAXPAYERS_ENDPOINT = `${API_BASE_URL}/taxpayers`;

const TAX_STATUS = {
  pending: { label: "En attente", color: "secondary" },
  paid: { label: "Payée", color: "success" },
  partial: { label: "Partielle", color: "warning" },
  overdue: { label: "Impayée", color: "danger" },
};

export default function ActivityDetails() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { user } = useAuth();
  
  // ✅ Récupérer l'id_marche depuis l'objet user
  const userMarcheId = user?.id_marche;
  const hasMarket = !!userMarcheId && userMarcheId !== 'null' && userMarcheId !== 'undefined';
  
  // ✅ Déterminer les libellés en fonction de la présence d'un marché
  const labels = hasMarket ? {
    title: "Détails de l'activité",
    back: "Retour",
    addContribuable: "Ajouter un contribuable",
    loading: "Chargement...",
    errorLoading: "Impossible de charger les détails",
    noDescription: "Aucune description",
    taxes: "Taxes redevances associées",
    assignTax: "Affecter une taxe redevance",
    noTaxFound: "Aucune taxe redevance trouvée",
    noTaxDesc: "Cette activité ne possède aucune taxe.",
    contribuables: "Contribuables",
    noContribuableFound: "Aucun contribuable trouvé",
    noContribuableDesc: "Aucun contribuable n'est associé à cette activité.",
    searchTax: "Rechercher une taxe...",
    searchContribuable: "Rechercher un contribuable...",
    allStatus: "Tous les statuts",
    pending: "En attente",
    paid: "Payée",
    partial: "Partielle",
    overdue: "Impayée",
    code: "Code",
    title: "Intitulé",
    amount: "Montant",
    frequency: "Fréquence",
    dueDate: "Date d'échéance",
    addedBy: "Ajouté par",
    actions: "Actions",
    removeTax: "Retirer",
    viewDetails: "Voir détails",
    assignTaxes: "Affecter des taxes redevances",
    cancel: "Annuler",
    save: "Enregistrer",
    remove: "Retirer",
    delete: "Supprimer",
    confirmRemove: "Retirer cette taxe redevance ?",
    confirmRemoveDesc: "Cette action est irréversible.",
    confirmBulkRemove: "Retirer plusieurs taxes redevances",
    confirmBulkRemoveDesc: "Vous allez retirer",
    taxDetails: "Détails de la taxe",
    frequencyDaily: "Journalière",
    frequencyMonthly: "Mensuelle",
    frequencyQuarterly: "Trimestrielle",
    frequencySemiannual: "Semestrielle",
    frequencyAnnual: "Annuelle",
    frequencyOneOff: "Paiement unique",
    statusActive: "Actif",
    statusInactive: "Inactif",
    idContribuable: "ID Contribuable",
    nameDenomination: "Nom / Dénomination",
    phone: "Téléphone",
    email: "Email",
    status: "Statut",
    registrationDate: "Date d'inscription",
    admin: "Admin",
    showing: "Affichage de",
    to: "à",
    of: "sur",
    contribuable: "contribuable(s)",
    taxpayer: "contribuable",
    tax: "taxe",
    taxesPlural: "taxes",
    assignedTaxes: "Taxes associées",
    removeSelected: "Retirer",
    affectTax: "Affecter une taxe redevance",
    noTaxAvailable: "Aucune taxe redevance disponible",
    noTaxAvailableDesc: "Toutes les taxes redevances sont déjà affectées à cette activité.",
    searchTaxPlaceholder: "Rechercher une taxe...",
    amountLabel: "Montant",
    frequencyLabel: "Fréquence",
    dueDateLabel: "Date d'échéance",
    selectTax: "Sélectionner une taxe redevance",
    addContribuableTitle: "Ajouter un contribuable",
    taxeId: "Code",
    taxName: "Intitulé",
    createdBy: "Créé par",
    createdAt: "Créé le",
    updatedAt: "Modifié le",
    exportId: "Export",
    category: "Catégorie",
    description: "Description",
    noData: "Aucune donnée",
    dashboard: "Tableau de bord",
    activities: "Activités",
    details: "Détails",
  } : {
    title: "Détails de l'activité",
    back: "Retour",
    addContribuable: "Ajouter un contribuable",
    loading: "Chargement...",
    errorLoading: "Impossible de charger les détails",
    noDescription: "Aucune description",
    taxes: "Taxes associées",
    assignTax: "Affecter une taxe",
    noTaxFound: "Aucune taxe trouvée",
    noTaxDesc: "Cette activité ne possède aucune taxe.",
    contribuables: "Contribuables",
    noContribuableFound: "Aucun contribuable trouvé",
    noContribuableDesc: "Aucun contribuable n'est associé à cette activité.",
    searchTax: "Rechercher une taxe...",
    searchContribuable: "Rechercher un contribuable...",
    allStatus: "Tous les statuts",
    pending: "En attente",
    paid: "Payée",
    partial: "Partielle",
    overdue: "Impayée",
    code: "Code",
    title: "Intitulé",
    amount: "Montant",
    frequency: "Fréquence",
    dueDate: "Date d'échéance",
    addedBy: "Ajouté par",
    actions: "Actions",
    removeTax: "Retirer",
    viewDetails: "Voir détails",
    assignTaxes: "Affecter des taxes",
    cancel: "Annuler",
    save: "Enregistrer",
    remove: "Retirer",
    delete: "Supprimer",
    confirmRemove: "Retirer cette taxe ?",
    confirmRemoveDesc: "Cette action est irréversible.",
    confirmBulkRemove: "Retirer plusieurs taxes",
    confirmBulkRemoveDesc: "Vous allez retirer",
    taxDetails: "Détails de la taxe",
    frequencyDaily: "Journalière",
    frequencyMonthly: "Mensuelle",
    frequencyQuarterly: "Trimestrielle",
    frequencySemiannual: "Semestrielle",
    frequencyAnnual: "Annuelle",
    frequencyOneOff: "Paiement unique",
    statusActive: "Actif",
    statusInactive: "Inactif",
    idContribuable: "ID Contribuable",
    nameDenomination: "Nom / Dénomination",
    phone: "Téléphone",
    email: "Email",
    status: "Statut",
    registrationDate: "Date d'inscription",
    admin: "Admin",
    showing: "Affichage de",
    to: "à",
    of: "sur",
    contribuable: "contribuable(s)",
    taxpayer: "contribuable",
    tax: "taxe",
    taxesPlural: "taxes",
    assignedTaxes: "Taxes associées",
    removeSelected: "Retirer",
    affectTax: "Affecter une taxe",
    noTaxAvailable: "Aucune taxe disponible",
    noTaxAvailableDesc: "Toutes les taxes sont déjà affectées à cette activité.",
    searchTaxPlaceholder: "Rechercher une taxe...",
    amountLabel: "Montant",
    frequencyLabel: "Fréquence",
    dueDateLabel: "Date d'échéance",
    selectTax: "Sélectionner une taxe",
    addContribuableTitle: "Ajouter un contribuable",
    taxeId: "Code",
    taxName: "Intitulé",
    createdBy: "Créé par",
    createdAt: "Créé le",
    updatedAt: "Modifié le",
    exportId: "Export",
    category: "Catégorie",
    description: "Description",
    noData: "Aucune donnée",
    dashboard: "Tableau de bord",
    activities: "Activités",
    details: "Détails",
  };

  // États pour l'activité
  const [activity, setActivity] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [assignedTaxes, setAssignedTaxes] = useState([]);
  const [availableTaxes, setAvailableTaxes] = useState([]);
  const [parentCategories, setParentCategories] = useState([]);
  const [categories, setCategories] = useState([]);
  
  // États pour les taxes
  const [loadingTaxes, setLoadingTaxes] = useState(false);
  const [assigningTaxes, setAssigningTaxes] = useState(false);
  const [selectedTaxes, setSelectedTaxes] = useState([]);
  const [showAssignTaxModal, setShowAssignTaxModal] = useState(false);
  const [showRemoveTaxModal, setShowRemoveTaxModal] = useState(false);
  const [showTaxDetailsModal, setShowTaxDetailsModal] = useState(false);
  const [showBulkRemoveModal, setShowBulkRemoveModal] = useState(false);
  const [selectedTax, setSelectedTax] = useState(null);
  const [taxToRemove, setTaxToRemove] = useState(null);
  const [bulkRemoveCount, setBulkRemoveCount] = useState(0);
  const [removingTax, setRemovingTax] = useState(false);
  const [toasts, setToasts] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("all");
  const [taxSearch, setTaxSearch] = useState("");
  const [taxConfigurations, setTaxConfigurations] = useState({});

  // États pour les contribuables
  const [contribuables, setContribuables] = useState([]);
  const [loadingContribuables, setLoadingContribuables] = useState(false);
  const [contribuablesError, setContribuablesError] = useState(null);
  const [contribuableSearchTerm, setContribuableSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalContribuables, setTotalContribuables] = useState(0);
  const itemsPerPage = 10;

  const defaultCurrency = sessionStorage.getItem("default_currency") || "XAF";

  const getAuthToken = () => sessionStorage.getItem("authToken");
  
  const getHeaders = () => {
    const token = getAuthToken();
    const headers = { "Content-Type": "application/json", Accept: "application/json" };
    if (token) headers["Authorization"] = `Bearer ${token}`;
    return headers;
  };

  const showToast = (message, type = "success", title = "") => {
    const id = Date.now();
    setToasts((prev) => [...prev, { id, message, type, title: title || (type === "success" ? "Succès" : type === "danger" ? "Erreur" : "Information") }]);
    setTimeout(() => setToasts((prev) => prev.filter((t) => t.id !== id)), 5000);
  };

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axios.get(CATEGORIES_ENDPOINT, { headers: getHeaders() });
        setCategories(res.data.data || []);
      } catch (e) { console.error(e); }
    };
    fetchCategories();
  }, []);

  const formatCurrency = (amount) => {
    const num = parseFloat(amount || 0);
    return num.toLocaleString("fr-FR", { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + " " + defaultCurrency;
  };

  const categoryMap = React.useMemo(() => new Map(categories.map(cat => [cat.category_id, cat])), [categories]);

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "-";
    return date.toLocaleDateString("fr-FR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric"
    });
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "Non spécifié";
    return new Date(dateString).toLocaleDateString("fr-FR", {
      day: "2-digit", month: "2-digit", year: "numeric",
      hour: "2-digit", minute: "2-digit"
    });
  };

  const handleAddContribuable = () => {
    navigate(`/agent/contribuables/ajouter?activite_id=${activity?.id_export}`);
  };

  const getActivityExportId = () => activity?.id_export;

  const fetchParentCategories = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/usager-categories`, { headers: getHeaders() });
      if (response.data && Array.isArray(response.data.data)) setParentCategories(response.data.data);
    } catch (error) { console.error(error); }
  };

  const fetchActivity = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_BASE_URL}/activites/${id}`, { headers: getHeaders() });
      if (response.data) {
        setActivity(response.data);
      }
    } catch (error) {
      console.error(error);
      setError(labels.errorLoading);
    } finally { 
      setLoading(false); 
    }
  };

  const fetchAssignedTaxes = async () => {
    try {
      const exportId = getActivityExportId();
      const response = await axios.get(`${API_BASE_URL}/taxes-activity/${exportId}`, { headers: getHeaders() });
      if (Array.isArray(response.data)) setAssignedTaxes(response.data);
      else if (response.data && Array.isArray(response.data.data)) setAssignedTaxes(response.data.data);
      else setAssignedTaxes([]);
    } catch (error) {
      console.error(error);
      setAssignedTaxes([]);
    }
  };

  const fetchAvailableTaxes = async () => {
    try {
      setLoadingTaxes(true);
      const response = await axios.get(`${API_BASE_URL}/taxes`, { headers: getHeaders() });
      let taxes = [];
      if (response.data && Array.isArray(response.data.data)) taxes = response.data.data;
      else if (Array.isArray(response.data)) taxes = response.data;
      
      const assignedIds = assignedTaxes.map((t) => t.taxe_id);
      const filtered = taxes.filter((tax) => !assignedIds.includes(tax.taxe_id));
      
      setAvailableTaxes(filtered);
    } catch (error) {
      console.error(error);
      setAvailableTaxes([]);
    } finally { 
      setLoadingTaxes(false); 
    }
  };

  // Charger les contribuables de l'activité avec pagination côté serveur
  const fetchContribuablesByActivity = async (page = 1) => {
    if (!activity?.id_export) return;
    
    try {
      setLoadingContribuables(true);
      setContribuablesError(null);
      
      const response = await axios.get(`${TAXPAYERS_ENDPOINT}/${activity.id_export}/activite`, {
        params: {
          page: page,
          per_page: itemsPerPage,
          sort_by: 'created_at',
          sort_order: 'desc'
        },
        headers: getHeaders()
      });
      
      if (response.data && response.data.success) {
        setContribuables(response.data.data || []);
        setTotalContribuables(response.data.meta?.total || 0);
        setTotalPages(response.data.meta?.last_page || 1);
        setCurrentPage(response.data.meta?.current_page || 1);
      } else if (response.data && Array.isArray(response.data)) {
        setContribuables(response.data);
        setTotalContribuables(response.data.length);
        setTotalPages(Math.ceil(response.data.length / itemsPerPage));
      } else {
        setContribuables([]);
        setTotalContribuables(0);
        setTotalPages(1);
      }
    } catch (error) {
      console.error("Erreur chargement contribuables:", error);
      setContribuablesError("Impossible de charger les contribuables");
      setContribuables([]);
      setTotalContribuables(0);
      setTotalPages(1);
    } finally {
      setLoadingContribuables(false);
    }
  };
  
  // Fonction pour changer de page
  const handlePageChange = (page) => {
    if (page !== currentPage && page >= 1 && page <= totalPages) {
      fetchContribuablesByActivity(page);
    }
  };

  useEffect(() => {
    if (id) {
      fetchActivity();
      fetchParentCategories();
    }
  }, [id]);

  useEffect(() => {
    if (activity) {
      fetchAssignedTaxes();
      fetchContribuablesByActivity(1);
    }
  }, [activity]);

  useEffect(() => {
    if (activity) fetchAvailableTaxes();
  }, [assignedTaxes, activity]);

  const handleTaxSelection = (tax) => {
    const exists = selectedTaxes.includes(tax.taxe_id);
    if (exists) {
      setSelectedTaxes((prev) => prev.filter((id) => id !== tax.taxe_id));
      setTaxConfigurations((prev) => {
        const updated = { ...prev };
        delete updated[tax.taxe_id];
        return updated;
      });
    } else {
      setSelectedTaxes((prev) => [...prev, tax.taxe_id]);
      setTaxConfigurations((prev) => ({
        ...prev,
        [tax.taxe_id]: {
          taxe_id: tax.taxe_id,
          montant: tax.montant || tax.default_amount || 0,
          frequence: tax.frequence || "monthly",
          date_echeance: tax.echeance_date,
        },
      }));
    }
  };

  const updateTaxConfiguration = (taxeId, field, value) => {
    setTaxConfigurations((prev) => ({ ...prev, [taxeId]: { ...prev[taxeId], [field]: value } }));
  };

  const formatFrequency = (value) => {
    const map = {
      daily: labels.frequencyDaily,
      monthly: labels.frequencyMonthly,
      quarterly: labels.frequencyQuarterly,
      semiannual: labels.frequencySemiannual,
      annual: labels.frequencyAnnual,
      one_off: labels.frequencyOneOff,
    };
    return map[value] || labels.frequencyMonthly;
  };

  const handleAssignTaxes = async () => {
    if (selectedTaxes.length === 0) {
      showToast("Veuillez sélectionner une taxe", "warning");
      return;
    }
    try {
      setAssigningTaxes(true);
      const exportId = getActivityExportId();
      const payload = { taxes: Object.values(taxConfigurations) };
      await axios.post(`${API_BASE_URL}/taxes-activity/${exportId}`, payload, { headers: getHeaders() });
      showToast("Taxes affectées avec succès", "success");
      setSelectedTaxes([]);
      setTaxConfigurations({});
      setShowAssignTaxModal(false);
      fetchAssignedTaxes();
    } catch (error) {
      console.error(error);
      showToast(error.response?.data?.message || "Erreur lors de l'affectation", "danger");
    } finally { setAssigningTaxes(false); }
  };

  const handleRemoveTax = async () => {
    if (!taxToRemove) return;
    try {
      setRemovingTax(true);
      const exportId = getActivityExportId();
      await axios.delete(`${API_BASE_URL}/taxes-activity/${exportId}`, {
        headers: getHeaders(),
        data: { taxe_ids: [taxToRemove.taxe_id] },
      });
      setShowRemoveTaxModal(false);
      setTaxToRemove(null);
      fetchAssignedTaxes();
      showToast("Taxe retirée avec succès", "success");
    } catch (error) {
      console.error(error);
      showToast("Erreur suppression", "danger");
    } finally { setRemovingTax(false); }
  };

  const handleBulkRemoveTaxes = async () => {
    try {
      setRemovingTax(true);
      const exportId = getActivityExportId();
      const taxe_ids = assignedTaxes.filter((t) => selectedTaxes.includes(t.id)).map((t) => t.taxe_id);
      await axios.delete(`${API_BASE_URL}/taxes-activity/${exportId}`, {
        headers: getHeaders(),
        data: { taxe_ids },
      });
      setSelectedTaxes([]);
      setShowBulkRemoveModal(false);
      fetchAssignedTaxes();
      showToast("Taxes retirées", "success");
    } catch (error) {
      console.error(error);
      showToast("Erreur suppression", "danger");
    } finally { setRemovingTax(false); }
  };

  const openBulkRemoveModal = () => {
    setBulkRemoveCount(selectedTaxes.length);
    setShowBulkRemoveModal(true);
  };

  const getTaxStatusBadge = (status) => {
    const item = TAX_STATUS[status] || TAX_STATUS.pending;
    return <Badge bg={item.color}>{item.label}</Badge>;
  };

  const getStatusBadge = (isActive) => {
    if (isActive === true || isActive === 1 || isActive === "1") {
      return (
        <Badge bg="success" className="d-inline-flex align-items-center gap-1 px-2 py-1">
          <CheckCircle size={10} />
          <span>{labels.statusActive}</span>
        </Badge>
      );
    }
    return (
      <Badge bg="secondary" className="d-inline-flex align-items-center gap-1 px-2 py-1">
        <XCircle size={10} />
        <span>{labels.statusInactive}</span>
      </Badge>
    );
  };

  const filteredTaxes = useMemo(() => {
    return assignedTaxes.filter((tax) => {
      if (searchTerm && !(tax.taxe_name || tax.titre || "").toLowerCase().includes(searchTerm.toLowerCase())) return false;
      if (selectedStatus !== "all" && tax.statut !== selectedStatus) return false;
      return true;
    });
  }, [assignedTaxes, searchTerm, selectedStatus]);

  // Recherche locale sur les contribuables déjà chargés
  const filteredContribuables = useMemo(() => {
    if (!contribuableSearchTerm) return contribuables;
    return contribuables.filter(c => 
      (c.nom_contribuable || c.nom_entite || "").toLowerCase().includes(contribuableSearchTerm.toLowerCase()) ||
      (c.telephone || "").includes(contribuableSearchTerm) ||
      (c.email || "").toLowerCase().includes(contribuableSearchTerm.toLowerCase())
    );
  }, [contribuables, contribuableSearchTerm]);

  if (loading) {
    return (
      <>
        <Header />
        <div className="main main-app p-4"><div className="d-flex justify-content-center align-items-center" style={{ minHeight: "70vh" }}><div className="text-center"><Spinner animation="border" variant="primary" /><h5 className="mt-3">{labels.loading}</h5></div></div></div>
        <Footer />
      </>
    );
  }

  if (error || !activity) {
    return (
      <>
        <Header />
        <div className="main main-app p-4"><Alert variant="danger">{error}</Alert></div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header />

      <ToastContainer className="p-3" style={{ zIndex: 9999, position: "fixed", top: 20, right: 20 }}>
        {toasts.map((toast) => (
          <Toast key={toast.id} autohide delay={5000} onClose={() => setToasts((prev) => prev.filter((t) => t.id !== toast.id))}>
            <Toast.Header className={`bg-${toast.type} text-white`}><strong className="me-auto">{toast.title}</strong></Toast.Header>
            <Toast.Body>{toast.message}</Toast.Body>
          </Toast>
        ))}
      </ToastContainer>

      <div className="main main-app p-3 p-lg-4" style={{ background: "#f5f7fb", minHeight: "100vh" }}>
        <div className="container-fluid">

          {/* HEADER */}
          <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-3">
            <div>
              <ol className="breadcrumb mb-2">
                <li className="breadcrumb-item"><Link to="">{labels.dashboard}</Link></li>
                <li className="breadcrumb-item"><Link to="/agent/contribuables/Activites">{labels.activities}</Link></li>
                <li className="breadcrumb-item active">{labels.details}</li>
              </ol>
              <Button variant="link" className="p-0 text-decoration-none" onClick={() => navigate("/agent/contribuables/Activites")}>
                <ArrowLeft className="me-2" /> {labels.back}
              </Button>
            </div>
            <Button variant="success" onClick={handleAddContribuable} className="d-flex align-items-center gap-2">
              <PersonPlus size={18} />
              {labels.addContribuable}
            </Button>
          </div>

          {/* CARD ACTIVITÉ */}
          <Card className="border-0 shadow-lg mb-4 overflow-hidden activity-card">
            <div className="activity-gradient" />
            <Card.Body className="p-4">
              <Row className="align-items-center g-4">
                <Col lg="auto"><div className="activity-icon"><Briefcase size={45} className="text-primary" /></div></Col>
                <Col lg>
                  <h2 className="fw-bold mb-3">{activity.name}</h2>
                  <div className="d-flex flex-wrap gap-2 mb-3">
                    <Badge bg="primary"><Folder className="me-1" /> {activity.cat_name}</Badge>
                    <Badge bg="dark"><Tag className="me-1" /> {labels.exportId}: {activity.id_export}</Badge>
                    <Badge bg="secondary"><Calendar className="me-1" /> {formatDateTime(activity.created_at)}</Badge>
                  </div>
                  <p className="text-muted mb-0">{activity.description || labels.noDescription}</p>
                </Col>
                <Col lg={2}>
                  <Card className="border-0 bg-success bg-opacity-10 stats-card">
                    <Card.Body className="text-center">
                      <Receipt className="text-success mb-2" size={35} />
                      <h3 className="mb-0 fw-bold">{assignedTaxes.length}</h3>
                      <small>{labels.tax}</small>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Card.Body>
          </Card>

          {/* TABS */}
          <Card className="border-0 shadow-sm">
            <Card.Body className="p-0">
              <Tabs defaultActiveKey="taxes" className="border-0 px-3 pt-3" fill>
                
                {/* TAB 1: Taxes associées */}
                <Tab eventKey="taxes" title={<span><Receipt className="me-2" size={16} />{labels.taxes} ({assignedTaxes.length})</span>}>
                  <div className="p-3">
                    <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                      <div className="d-flex gap-2">
                        {selectedTaxes.length > 0 && (
                          <Button variant="outline-danger" size="sm" onClick={openBulkRemoveModal}>
                            <Trash className="me-2" size={14} /> {labels.removeSelected} ({selectedTaxes.length})
                          </Button>
                        )}
                        <Button variant="primary" size="sm" onClick={() => setShowAssignTaxModal(true)}>
                          <PlusCircle className="me-2" size={14} /> {labels.affectTax}
                        </Button>
                      </div>
                    </div>

                    {/* FILTERS */}
                    <Row className="mb-4 g-3">
                      <Col lg={8}>
                        <InputGroup>
                          <InputGroup.Text><Search size={16} /></InputGroup.Text>
                          <Form.Control placeholder={labels.searchTax} value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                        </InputGroup>
                      </Col>
                      <Col lg={4}>
                        <Form.Select value={selectedStatus} onChange={(e) => setSelectedStatus(e.target.value)}>
                          <option value="all">{labels.allStatus}</option>
                          <option value="pending">{labels.pending}</option>
                          <option value="paid">{labels.paid}</option>
                          <option value="partial">{labels.partial}</option>
                          <option value="overdue">{labels.overdue}</option>
                        </Form.Select>
                      </Col>
                    </Row>

                    {/* TABLEAU DES TAXES */}
                    <div className="table-responsive">
                      <Table hover className="align-middle mb-0 modern-table">
                        <thead className="table-light">
                          <tr>
                            <th style={{ width: "40px" }}>
                              <Form.Check checked={selectedTaxes.length === filteredTaxes.length && filteredTaxes.length > 0} 
                                onChange={(e) => { if (e.target.checked) setSelectedTaxes(filteredTaxes.map((t) => t.id)); else setSelectedTaxes([]); }} />
                            </th>
                            <th>{labels.taxeId}</th>
                            <th>{labels.taxName}</th>
                            <th>{labels.amount}</th>
                            <th>{labels.frequency}</th>
                            <th>{labels.dueDate}</th>
                            <th>{labels.createdBy}</th>
                            <th className="text-end">{labels.actions}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredTaxes.length > 0 ? filteredTaxes.map((tax, idx) => (
                            <tr key={idx} className="tax-row">
                              <td><Form.Check checked={selectedTaxes.includes(tax.id)} onChange={() => { if (selectedTaxes.includes(tax.id)) setSelectedTaxes((prev) => prev.filter((t) => t !== tax.id)); else setSelectedTaxes((prev) => [...prev, tax.id]); }} /></td>
                              <td><Badge bg="secondary">{tax.taxe_id}</Badge></td>
                              <td><div className="d-flex flex-column"><strong>{tax.taxe_name || tax.titre}</strong>{tax.description && <small className="text-muted">{tax.description.length > 60 ? `${tax.description.substring(0, 60)}...` : tax.description}</small>}</div></td>
                              <td><div className="d-flex align-items-center"><Wallet size={14} className="text-primary me-1" /><span className="fw-bold text-primary">{formatCurrency(tax.montant || tax.default_amount)}</span></div></td>
                              <td><Badge bg="info"><ClockHistory size={10} className="me-1" />{formatFrequency(tax.default_frequency)}</Badge></td>
                              <td>{formatDate(tax.echeance_date)}</td>
                              <td>{tax.admin_fname} {tax.admin_lname}</td>
                              <td className="text-end">
                                <div className="d-flex gap-2 justify-content-end">
                                  <Button size="sm" variant="outline-info" className="action-btn" onClick={() => { setSelectedTax(tax); setShowTaxDetailsModal(true); }}><Eye size={14} /></Button>
                                  <Button size="sm" variant="outline-danger" className="action-btn" onClick={() => { setTaxToRemove(tax); setShowRemoveTaxModal(true); }}><Trash size={14} /></Button>
                                </div>
                              </td>
                            </tr>
                          )) : (
                            <tr><td colSpan="7" className="text-center py-5">
                              <div className="empty-state"><Receipt size={55} className="empty-icon" /><h5 className="mt-3">{labels.noTaxFound}</h5><p className="text-muted">{labels.noTaxDesc}</p>
                              <Button variant="primary" onClick={() => { fetchAvailableTaxes(); setShowAssignTaxModal(true); }}><PlusCircle className="me-2" />{labels.affectTax}</Button></div>
                            </td></tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </Tab>

                {/* TAB 2: Contribuables de l'activité */}
                <Tab eventKey="contribuables" title={<span><People className="me-2" size={16} />{labels.contribuables} ({totalContribuables})</span>}>
                  <div className="p-3">
                    <Row className="mb-4">
                      <Col lg={6}>
                        <InputGroup>
                          <InputGroup.Text><Search size={16} /></InputGroup.Text>
                          <Form.Control 
                            placeholder={labels.searchContribuable} 
                            value={contribuableSearchTerm} 
                            onChange={(e) => {
                              setContribuableSearchTerm(e.target.value);
                              setCurrentPage(1);
                            }} 
                          />
                        </InputGroup>
                      </Col>
                    </Row>

                    {loadingContribuables ? (
                      <div className="text-center py-5"><Spinner animation="border" variant="primary" /><p className="mt-3">Chargement des contribuables...</p></div>
                    ) : contribuablesError ? (
                      <Alert variant="danger" className="text-center">{contribuablesError}</Alert>
                    ) : filteredContribuables.length === 0 ? (
                      <div className="text-center py-5">
                        <People size={55} className="text-muted opacity-25 mb-3" />
                        <h5 className="mt-3">{labels.noContribuableFound}</h5>
                        <p className="text-muted">{labels.noContribuableDesc}</p>
                        <Button variant="primary" onClick={handleAddContribuable}><PersonPlus className="me-2" />{labels.addContribuable}</Button>
                      </div>
                    ) : (
                      <>
                        <div className="table-responsive">
                          <Table hover className="align-middle mb-0">
                            <thead className="table-light">
                              <tr>
                                <th style={{ width: '80px' }}>{labels.idContribuable}</th>
                                <th>{labels.nameDenomination}</th>
                                <th style={{ width: '150px' }}>{labels.phone}</th>
                                <th style={{ width: '200px' }}>{labels.email}</th>
                                <th style={{ width: '100px' }}>{labels.status}</th>
                                <th style={{ width: '120px' }}>{labels.registrationDate}</th>
                                <th style={{ width: '80px' }} className="text-end">{labels.actions}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {filteredContribuables.map((contribuable) => (
                                <tr key={contribuable.id || contribuable.contribuable_id} className="contribuable-row">
                                  <td>
                                    <Badge bg="secondary" className="fw-semibold">
                                      {contribuable.contribuable_id || contribuable.id}
                                    </Badge>
                                  </td>
                                  <td>
                                    <div className="d-flex align-items-center">
                                      <div className="bg-light rounded-circle d-flex align-items-center justify-content-center flex-shrink-0 me-2" style={{ width: 32, height: 32 }}>
                                        <Person size={14} className="text-muted" />
                                      </div>
                                      <div className="flex-grow-1">
                                        <strong>{contribuable.nom_contribuable || contribuable.nom_entite || "-"}</strong>
                                        {contribuable.admin?.full_name && (
                                          <small className="d-block text-muted">
                                            {labels.admin}: {contribuable.admin.full_name}
                                          </small>
                                        )}
                                      </div>
                                    </div>
                                   </td>
                                  <td>
                                    <div className="d-flex align-items-center">
                                      <Phone size={12} className="me-1 text-muted flex-shrink-0" />
                                      <span className="text-truncate" style={{ maxWidth: '120px' }}>
                                        {contribuable.telephone || "-"}
                                      </span>
                                    </div>
                                   </td>
                                  <td>
                                    <div className="d-flex align-items-center">
                                      <Envelope size={12} className="me-1 text-muted flex-shrink-0" />
                                      <span className="text-truncate" style={{ maxWidth: '160px' }}>
                                        {contribuable.email || "-"}
                                      </span>
                                    </div>
                                   </td>
                                  <td>{getStatusBadge(contribuable.is_active !== undefined ? contribuable.is_active : true)}</td>
                                  <td><small>{contribuable.created_at ? formatDate(contribuable.created_at) : "-"}</small></td>
                                  <td className="text-end">
                                    <Button 
                                      as={Link} 
                                      to={`/agent/ContribuableDetails/${contribuable.contribuable_id || contribuable.id}`} 
                                      size="sm" 
                                      variant="outline-primary" 
                                      className="action-btn" 
                                      title={labels.viewDetails}
                                    >
                                      <Eye size={14} />
                                    </Button>
                                   </td>
                                 </tr>
                              ))}
                            </tbody>
                          </Table>
                        </div>

                        {/* Pagination */}
                        {totalPages > 1 && (
                          <div className="d-flex justify-content-between align-items-center mt-4 pt-3 border-top">
                            <div className="text-muted small">
                              <InfoCircle size={12} className="me-1" />
                              {labels.showing} {(currentPage - 1) * itemsPerPage + 1} {labels.to} {Math.min(currentPage * itemsPerPage, totalContribuables)} {labels.of} {totalContribuables} {labels.contribuable}
                            </div>
                            <Pagination className="mb-0">
                              <Pagination.Prev 
                                disabled={currentPage === 1} 
                                onClick={() => handlePageChange(currentPage - 1)}
                              />
                              {[...Array(Math.min(totalPages, 5))].map((_, i) => {
                                let pageNum;
                                if (totalPages <= 5) {
                                  pageNum = i + 1;
                                } else if (currentPage <= 3) {
                                  pageNum = i + 1;
                                } else if (currentPage >= totalPages - 2) {
                                  pageNum = totalPages - 4 + i;
                                } else {
                                  pageNum = currentPage - 2 + i;
                                }
                                return (
                                  <Pagination.Item 
                                    key={pageNum} 
                                    active={pageNum === currentPage} 
                                    onClick={() => handlePageChange(pageNum)}
                                  >
                                    {pageNum}
                                  </Pagination.Item>
                                );
                              })}
                              <Pagination.Next 
                                disabled={currentPage === totalPages} 
                                onClick={() => handlePageChange(currentPage + 1)}
                              />
                            </Pagination>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </Tab>
              </Tabs>
            </Card.Body>
          </Card>

        </div>
        <Footer />
      </div>

      {/* ASSIGN TAX MODAL */}
      <Modal show={showAssignTaxModal} onHide={() => { setShowAssignTaxModal(false); setTaxSearch(""); setSelectedTaxes([]); setTaxConfigurations({}); }} size="xl" centered scrollable>
        <Modal.Header closeButton className="bg-primary text-white border-0">
          <Modal.Title><PlusCircle className="me-2" />{labels.assignTaxes}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ background: "#f8f9fa" }}>
          
          <Card className="border-0 shadow-sm mb-3">
            <Card.Body>
              <InputGroup>
                <InputGroup.Text><Search /></InputGroup.Text>
                <Form.Control 
                  placeholder={labels.searchTaxPlaceholder} 
                  value={taxSearch} 
                  onChange={(e) => setTaxSearch(e.target.value)} 
                />
              </InputGroup>
            </Card.Body>
          </Card>
          
          {loadingTaxes ? (
            <div className="text-center py-5"><Spinner animation="border" /></div>
          ) : availableTaxes.length === 0 ? (
            <div className="text-center py-5">
              <Receipt size={48} className="text-muted opacity-25 mb-3" />
              <h6>{labels.noTaxAvailable}</h6>
              <p className="text-muted">{labels.noTaxAvailableDesc}</p>
            </div>
          ) : (
            <div className="taxes-list">
              {availableTaxes
                .filter((tax) => 
                  (tax.titre || tax.taxe_name || "").toLowerCase().includes(taxSearch.toLowerCase())
                )
                .map((tax) => {
                  const category = categoryMap.get(tax.tax_category);
                  const isSelected = selectedTaxes.includes(tax.taxe_id);
                  return (
                    <Card 
                      key={tax.taxe_id} 
                      className={`tax-selection-card mb-3 ${isSelected ? "selected border-primary" : ""}`}
                      style={{ cursor: "pointer", borderRadius: "16px" }}
                    >
                      <Card.Body>
                        <div className="d-flex align-items-start">
                          <Form.Check 
                            className="me-3 mt-1" 
                            checked={isSelected}
                            onChange={() => handleTaxSelection(tax)}
                          />
                          <div className="flex-grow-1">
                            <div className="d-flex justify-content-between flex-wrap gap-2">
                              <div>
                                <div className="d-flex align-items-center gap-2 flex-wrap">
                                  <h6 className="fw-bold mb-0">{tax.titre || tax.taxe_name}</h6>
                                  <Badge bg="secondary" className="px-2 py-1">{tax.taxe_id}</Badge>
                                  {category && (
                                    <Badge bg="info" className="d-inline-flex align-items-center px-2 py-1">
                                      {category.category_name}
                                    </Badge>
                                  )}
                                </div>
                                {tax.description && (
                                  <small className="text-muted d-block mt-1">{tax.description}</small>
                                )}
                              </div>
                            </div>
                            
                            {isSelected && (
                              <div className="mt-3 pt-3 border-top">
                                <Row className="g-3">
                                  <Col md={4}>
                                    <Form.Group>
                                      <Form.Label className="fw-semibold small">{labels.amountLabel}</Form.Label>
                                      <InputGroup>
                                        <Form.Control 
                                          type="number" 
                                          value={taxConfigurations[tax.taxe_id]?.montant || tax.montant || tax.default_amount || ""} 
                                          onChange={(e) => updateTaxConfiguration(tax.taxe_id, "montant", e.target.value)}
                                        />
                                        <InputGroup.Text>{defaultCurrency}</InputGroup.Text>
                                      </InputGroup>
                                    </Form.Group>
                                  </Col>
                                  <Col md={4}>
                                    <Form.Group>
                                      <Form.Label className="fw-semibold small">{labels.frequencyLabel}</Form.Label>
                                      <Form.Select 
                                        value={taxConfigurations[tax.taxe_id]?.frequence || "monthly"} 
                                        onChange={(e) => updateTaxConfiguration(tax.taxe_id, "frequence", e.target.value)}
                                      >
                                        <option value="daily">{labels.frequencyDaily}</option>
                                        <option value="monthly">{labels.frequencyMonthly}</option>
                                        <option value="quarterly">{labels.frequencyQuarterly}</option>
                                        <option value="semiannual">{labels.frequencySemiannual}</option>
                                        <option value="annual">{labels.frequencyAnnual}</option>
                                        <option value="one_off">{labels.frequencyOneOff}</option>
                                      </Form.Select>
                                    </Form.Group>
                                  </Col>
                                  <Col md={4}>
                                    <Form.Group>
                                      <Form.Label className="fw-semibold small">{labels.dueDateLabel}</Form.Label>
                                      <Form.Control 
                                        type="date" 
                                        value={taxConfigurations[tax.taxe_id]?.date_echeance || ""} 
                                        onChange={(e) => updateTaxConfiguration(tax.taxe_id, "date_echeance", e.target.value)}
                                      />
                                    </Form.Group>
                                  </Col>
                                </Row>
                              </div>
                            )}
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  );
                })}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="border-0 bg-white">
          <Button variant="light" onClick={() => setShowAssignTaxModal(false)}>{labels.cancel}</Button>
          <Button 
            variant="primary" 
            onClick={handleAssignTaxes} 
            disabled={assigningTaxes || selectedTaxes.length === 0}
          >
            {assigningTaxes ? (
              <><Spinner size="sm" className="me-2" />Affectation...</>
            ) : (
              <><PlusCircle className="me-2" />{labels.affectTax} ({selectedTaxes.length})</>
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* REMOVE MODAL */}
      <Modal show={showRemoveTaxModal} onHide={() => setShowRemoveTaxModal(false)} centered>
        <Modal.Body className="text-center p-4"><div className="mb-3"><div className="danger-icon"><ExclamationTriangle size={38} /></div></div><h4 className="fw-bold">{labels.confirmRemove}</h4><p className="text-muted">{labels.confirmRemoveDesc}</p><div className="d-flex justify-content-center gap-2 mt-4"><Button variant="light" onClick={() => setShowRemoveTaxModal(false)}>{labels.cancel}</Button><Button variant="danger" onClick={handleRemoveTax} disabled={removingTax}>{removingTax ? (<><Spinner size="sm" className="me-2" />Suppression...</>) : (<><Trash className="me-2" />{labels.remove}</>)}</Button></div></Modal.Body>
      </Modal>

      {/* DETAILS MODAL */}
      <Modal show={showTaxDetailsModal} onHide={() => setShowTaxDetailsModal(false)} centered>
        <Modal.Header closeButton><Modal.Title>{labels.taxDetails}</Modal.Title></Modal.Header>
        <Modal.Body>{selectedTax && (<div className="tax-details"><div className="detail-item"><span>{labels.taxName}</span><strong>{selectedTax.taxe_name || selectedTax.titre}</strong></div><div className="detail-item"><span>{labels.amount}</span><strong className="text-primary">{formatCurrency(selectedTax.montant || selectedTax.default_amount)}</strong></div><div className="detail-item"><span>{labels.frequency}</span><strong>{formatFrequency(selectedTax.default_frequency)}</strong></div><div className="detail-item"><span>{labels.status}</span><div>{getTaxStatusBadge(selectedTax.statut)}</div></div><div className="detail-item"><span>{labels.dueDate}</span><strong>{formatDate(selectedTax.echeance_date)}</strong></div></div>)}</Modal.Body>
      </Modal>

      {/* BULK REMOVE MODAL */}
      <Modal show={showBulkRemoveModal} onHide={() => setShowBulkRemoveModal(false)} centered>
        <Modal.Body className="text-center p-4"><div className="mb-3"><div className="danger-icon"><Trash size={34} /></div></div><h4 className="fw-bold">{labels.confirmBulkRemove}</h4><p className="text-muted">{labels.confirmBulkRemoveDesc} <strong>{bulkRemoveCount}</strong> {labels.taxesPlural}.</p><div className="d-flex justify-content-center gap-2 mt-4"><Button variant="light" onClick={() => setShowBulkRemoveModal(false)}>{labels.cancel}</Button><Button variant="danger" onClick={handleBulkRemoveTaxes} disabled={removingTax}>{removingTax ? (<><Spinner size="sm" className="me-2" />Suppression...</>) : (<><Trash className="me-2" />{labels.remove}</>)}</Button></div></Modal.Body>
      </Modal>

      <style>{`
        body{ background:#f5f7fb; }
        .activity-gradient{ height:6px; background:linear-gradient(135deg,#0d6efd,#4f8cff); }
        .activity-card{ border-radius:24px; }
        .activity-icon{ width:100px; height:100px; border-radius:50%; display:flex; align-items:center; justify-content:center; background:rgba(13,110,253,.08); }
        .stats-card{ border-radius:18px; }
        .modern-table thead th{ border:none; font-size:.85rem; text-transform:uppercase; color:#6c757d; font-weight:700; padding:1rem; background:#f8f9fa; }
        .modern-table tbody td{ border-color:#f1f3f5; padding:1rem; vertical-align:middle; }
        .tax-row:hover, .contribuable-row:hover{ background:#f8fbff; transform:translateX(2px); transition:all .25s ease; }
        .action-btn{ border-radius:12px; width:36px; height:36px; display:flex; align-items:center; justify-content:center; transition:all .2s ease; }
        .action-btn:hover{ transform:scale(1.08); }
        .empty-state{ padding:30px; }
        .empty-icon{ opacity:.2; }
        .tax-selection-card{ border-radius:18px; border:1px solid #e9ecef; transition:all .25s ease; }
        .tax-selection-card:hover{ transform:translateY(-2px); box-shadow:0 10px 25px rgba(0,0,0,.06); }
        .tax-selection-card.selected{ border:2px solid #0d6efd; background:#f8fbff; }
        .danger-icon{ width:80px; height:80px; border-radius:50%; margin:auto; background:rgba(220,53,69,.1); display:flex; align-items:center; justify-content:center; color:#dc3545; }
        .detail-item{ display:flex; justify-content:space-between; align-items:center; padding:14px 0; border-bottom:1px solid #f1f3f5; }
        .detail-item:last-child{ border-bottom:none; }
        .modal-content{ border:none; border-radius:24px; overflow:hidden; }
        .form-control, .form-select, .input-group-text{ border-radius:12px !important; min-height:46px; }
        .btn{ border-radius:12px; font-weight:600; }
        .badge{ font-weight:600; border-radius:8px; }
        .nav-tabs{ border-bottom: none; gap: 8px; }
        .nav-tabs .nav-link{ border: none; border-radius: 12px; padding: 10px 20px; color: #6c757d; font-weight: 500; transition: all 0.2s ease; }
        .nav-tabs .nav-link:hover{ background: #e9ecef; color: #0d6efd; }
        .nav-tabs .nav-link.active{ background: #0d6efd; color: white; box-shadow: 0 4px 12px rgba(13,110,253,0.3); }
        @media(max-width:768px){ .activity-icon{ width:75px; height:75px; } .activity-card h2{ font-size:1.3rem; } .modern-table{ min-width:900px; } .btn{ width:100%; } .nav-tabs .nav-link{ padding: 8px 12px; font-size: 14px; } }
        .contribuable-row{ transition: all 0.25s ease; cursor: pointer; }
        .contribuable-row:hover{ background-color: #f8fbff; transform: translateX(2px); }
        .text-truncate{ overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
        .pagination .page-link{ border-radius: 8px !important; margin: 0 2px; color: #0d6efd; }
        .pagination .page-item.active .page-link{ background-color: #0d6efd; border-color: #0d6efd; color:white; }
        .pagination .page-item.disabled .page-link{ color: #6c757d; }
      `}</style>

    </>
  );
}